import { Clock, CheckCircle, XCircle } from "lucide-react";
import { ProductListConfig } from "../components/Datatable/DataTable";

export interface TableQuote {
  id: string;
  rfqName: string;
  amount: string;
  terms: string;
  status: "pending" | "accepted" | "rejected";
  submittedDate: string;
}

// Note: mockQuotes removed - Quotes/RFQ backend endpoints not yet implemented
// TODO: Implement quotes/RFQ backend endpoints and replace with API calls
// For now, QuotesTable component uses this mock data
export const mockQuotes: TableQuote[] = [];

export function getStatusProps(status: string) {
  switch (status) {
    case "pending":
      return {
        icon: <Clock className="w-4 h-4 text-yellow-700" />,
        classes: "bg-yellow-100 text-yellow-700 hover:bg-yellow-200",
      };
    case "accepted":
      return {
        icon: <CheckCircle className="w-4 h-4 text-green-700" />,
        classes: "bg-green-100 text-green-700 hover:bg-green-200",
      };
    case "rejected":
      return {
        icon: <XCircle className="w-4 h-4 text-red-700" />,
        classes: "bg-red-100 text-red-700 hover:bg-red-200",
      };
    default:
      return {
        icon: null,
        classes: "bg-gray-100 text-gray-700",
      };
  }
}

// ✅ table config
export const quotesTableConfig: ProductListConfig = {
  columns: [
    { key: "rfqName", label: "RFQ Name" },
    { key: "amount", label: "Amount" },
    { key: "terms", label: "Terms" },
    { key: "status", label: "Status", align: "center" },
    { key: "submittedDate", label: "Submitted", width: "w-40" },
    { key: "actions", label: "Actions", align: "center", width: "w-40" },
    { key: "message", label: "Message", align: "center", width: "w-20" },
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
  },
};
